module.exports = __webpack_public_path__ + "static/img/mango-m.db1adc4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backgrounds/mango-m.jpg
// module id = Bc2q
// module chunks = 0